export default __webpack_public_path__ + "static/media/chinafile-4.59fc0a9d.png";